import { Col, GridContainer, GridItem } from "@amzn/stencil-react-components/layout";
import { Text } from "@amzn/stencil-react-components/text";
import IconSearchLarge from "@amzn/stencil-react-icons/icons/icon-search-large";
import Button, { ButtonVariant } from "@amzn/uxm-stencil-react-components/lib/src/stencil/button";
import { PageMainContainer } from "common/components/PageMainContainer/PageMainContainer";
import { Paths } from "common/paths/paths";
import { getString } from "common/uistringlabels/uiStringUtils";
import React, { FC } from "react";
import { useHistory } from "react-router-dom";

export const UseCaseNotFound: FC = () => {
  const history = useHistory();

  return (
    <PageMainContainer paddingTop="100px">
      <GridContainer>
        <GridItem lg={4} />
        <GridItem lg={4}>
          <Col gridGap="S500" alignItems="center">
            <IconSearchLarge color="neutral50" title={getString("useCases.detail.notFound")} />
            <Text fontSize="T300" fontWeight="bold">
              {getString("useCases.detail.notFound")}
            </Text>
            <Text fontSize="T200" textAlign="center" color="color.text.secondary">
              {getString("useCases.detail.notFoundDescription")}
            </Text>
            <Button
              variant={ButtonVariant.Primary}
              onClick={() => history.push(Paths.aiForMeUseCases.url)}
              touchpoint="usecase-not-found-browse"
            >
              {getString("useCases.detail.notFoundBackButton")}
            </Button>
          </Col>
        </GridItem>
        <GridItem lg={4} />
      </GridContainer>
    </PageMainContainer>
  );
};
